import type { EngineConfig } from '../../types';
import type { MessageCallbacks } from './types';

export function handleHeartbeat(obj: any, cb: MessageCallbacks): boolean {
  if (!(obj?.kind === 'HEARTBEAT' || obj?.type === 'HEARTBEAT')) return false;

  cb.setDarHealth(prev => ({
    ...prev,
    fixLoggedOn: Boolean(obj.fix_logged_on),
    fixSessionStatus: obj.fix_logged_on ? 'CONNECTED' : 'DISCONNECTED',
    lastHeartbeatAt: obj.timestamp ?? new Date().toISOString(),
    pendingOrders: obj.pending_orders ?? prev.pendingOrders,
    instrumentsLoaded: obj.instruments_loaded ?? prev.instrumentsLoaded,
    sessionId: obj.session_id ?? prev.sessionId,
  }));
  return true;
}

export function handleFixSessionEvent(obj: any, cb: MessageCallbacks): boolean {
  if (!(obj?.kind === 'FIX_SESSION_EVENT' || obj?.type === 'FIX_SESSION_EVENT')) return false;

  const eventType = (obj.event_type ?? '').toUpperCase();
  cb.setDarHealth(prev => ({
    ...prev,
    fixLoggedOn: eventType === 'LOGON',
    fixSessionStatus: eventType === 'LOGON' ? 'CONNECTED'
      : eventType === 'LOGOUT' ? 'DISCONNECTED'
      : eventType === 'RECONNECTING' ? 'RECONNECTING'
      : prev.fixSessionStatus,
    sessionId: obj.session_id ?? prev.sessionId,
    lastHeartbeatAt: obj.timestamp ?? prev.lastHeartbeatAt,
  }));
  return true;
}

export function handleConfigAck(obj: any, cb: MessageCallbacks): boolean {
  if (!(obj?.kind === 'CONFIG_ACK' || obj?.type === 'CONFIG_ACK')) return false;

  const status = obj.status === 'ok' ? 'ok' : 'error';
  cb.setConfigAckStatus(status);
  cb.setConfigAckTime(obj.timestamp ?? new Date().toISOString());
  cb.setConfigAckErrors(obj.errors && typeof obj.errors === 'object' ? obj.errors : null);
  if (obj.applied && typeof obj.applied === 'object') {
    cb.setEngineConfig(prev => ({ ...(prev ?? {} as EngineConfig), ...obj.applied }));
  }
  return true;
}
